<template>
    <div id="draw-seal">
        <!-- <van-overlay :show="signLoading" :zIndex="9999" :custom-style="{backgroundColor: 'rgba(255,255,255,0)'}">
            <van-loading size="28px" text-size="16px" vertical color="#0094ff">签署中...</van-loading>
        </van-overlay> -->
        <div class="tip-success" id="tip-success">绘制成功</div>
        <div class="tip-waning" id="tip-waning"></div>
        <div class="main">
            <canvas id="seal-canvas" v-draw="{ hideDrawTip }"></canvas>
            <div class="draw-tip" v-show="!isDraw">
                <img src="../../assets/images/draw-icon.png" alt=""/>
                <p>请将手机横屏，绘制手写签名</p>
            </div>
            <div class="draw-btns">

                <div class="colorDiv">
                    <div class="colorText">
                        <p>颜色选择</p>
                    </div>
                    <div class="blackSelected" v-if="isBlack">
                        <div class="blackBored">
                            <div class="blackColor"></div>
                        </div>
                        <div class="redColor" @click="switchColor(false)"></div>
                    </div>
                    <div class="redSelected" v-else>
                        <div class="blackColor" @click="switchColor(true)"></div>
                        <div class="redBored">
                            <div class="redColor"></div>
                        </div>
                    </div>
                </div>
                <div class="btnDiv">
                    <el-button class="chongxieBtn" type="primary" @click="clearSign" id="clear" :disabled="!isDraw">重写
                    </el-button>
                    <el-button class="wanchengBtn" type="primary" @click="drawSign" id="submit"
                               :disabled="!isDraw">完成
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {submitHandwrite, handWriteQrcodeScanned} from '@/api/common'

    export default {
        data() {
            return {
                isDraw: false,
                signLoading: false,
                returnUrl: null,
                sid: "",
                signId: "",
                authId: "",
                isBlack: true
            };
        },
        created() {
            this.sid = this.$route.query.sid;
            document.title = "手绘签名";
        },
        directives: {
            draw: {
                inserted: function (el, binding) {
                    const canvas = document.querySelector("#seal-canvas");
                    const ctx = canvas.getContext("2d");
                    canvas.width = document.documentElement.clientWidth;
                    canvas.height = document.documentElement.clientHeight;

                    canvas.parentNode.addEventListener("touchstart", function (e) {
                        ctx.beginPath();
                        ctx.lineWidth = 4;

                        console.log(binding.value.isBlack)
                        if (ctx.strokeStyle == '#000000') { // 如果初始颜色为白色，则默认设置为黑色
                            ctx.strokeStyle = "black";
                        }
                        ctx.lineCap = ctx.lineJoin = "round";
                        const x = e.changedTouches[0].pageX;
                        const y = e.changedTouches[0].pageY;
                        ctx.lineTo(x, y);
                    });

                    canvas.parentNode.addEventListener("touchmove", function (e) {
                        if (!binding.value.isDraw) {
                            binding.value.hideDrawTip();
                        }
                        e.preventDefault();
                        const x = e.changedTouches[0].pageX;
                        const y = e.changedTouches[0].pageY;
                        ctx.lineTo(x, y);
                        ctx.stroke();
                    });

                    canvas.addEventListener("touchend", function () {
                        ctx.closePath();
                    });
                }
            }
        },
        mounted() {
            handWriteQrcodeScanned({
                sid: this.sid,
            }).then((res) => {
                if (res.code !== 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                    });
                } else {

                }
            })
        },
        methods: {
            hideDrawTip() {
                this.isDraw = true;
            },

            switchColor(isBlack) {
                this.isBlack = isBlack;
                const canvas = document.querySelector("#seal-canvas");
                const signCanvas = document.querySelector("#seal-canvas");
                const ctx = canvas.getContext("2d");
                if (isBlack) {
                    ctx.strokeStyle = "black";
                } else {
                    ctx.strokeStyle = "red";
                }
                ctx.clearRect(
                    0,
                    0,
                    signCanvas.offsetWidth,
                    signCanvas.offsetHeight
                );
                this.isDraw = false;
            },

            drawSign() {
                if (!this.isDraw) {
                    // Notify({type: "warning", message: "请先进行手绘印章"});
                    alert("请先进行手绘印章");
                    return;
                }

                function rotateBase64(data) {
                    //传入需要旋转的base64图片
                    return new Promise(resolve => {
                        const imgView = new Image();
                        imgView.src = data;
                        const canvas = document.createElement("canvas");
                        const context = canvas.getContext("2d");
                        const cutCoor = {
                            sx: 0,
                            sy: 0,
                            ex: 0,
                            ey: 0
                        }; // 裁剪坐标
                        imgView.onload = () => {
                            const imgW = imgView.width;
                            const imgH = imgView.height;
                            const size = imgH;
                            canvas.width = size * 2;
                            canvas.height = size * 2;
                            cutCoor.sx = size;
                            cutCoor.sy = size - imgW;
                            cutCoor.ex = size + imgH;
                            cutCoor.ey = size + imgW;
                            context.translate(size, size);
                            context.rotate((Math.PI / 2) * 3);
                            context.drawImage(imgView, 0, 0);
                            const imgData = context.getImageData(
                                cutCoor.sx,
                                cutCoor.sy,
                                cutCoor.ex,
                                cutCoor.ey
                            );
                            canvas.width = imgH;
                            canvas.height = imgW;
                            context.putImageData(imgData, 0, 0);
                            resolve(canvas.toDataURL("image/png"));
                        };
                    });
                }

                let basedata = document
                    .querySelector("#seal-canvas")
                    .toDataURL("image/png", 1);
                rotateBase64(basedata).then(img => {
                    console.log(img)
                    submitHandwrite({
                        sid: this.sid,
                        imgBase64: img
                    }).then((res) => {
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            this.$router.push("/open/seal/handwriteSuccess");
                        }
                    })
                });
            },
            clearSign() {
                const canvas = document.querySelector("#seal-canvas");
                const signCanvas = document.querySelector("#seal-canvas");
                const ctx = canvas.getContext("2d");
                ctx.clearRect(
                    0,
                    0,
                    signCanvas.offsetWidth,
                    signCanvas.offsetHeight
                );
                this.isDraw = false;
            },

        }
    };
</script>
<style lang="scss" scoped>
    .van-loading {
        margin-top: 40vh;
    }

    #draw-seal {
        width: 100vw;
        height: 100vh;
        user-select: none;
    }

    #seal-canvas {
        width: 100%;
        height: 100%;
        background: white;
        position: absolute;
        left: 0;
        top: 0;

    }

    .draw-tip {
        font-size: 1rem;
        transform: translateX(-50%) translateY(-50%) rotate(90deg);
        position: absolute;
        left: 60%;
        top: 50%;
        letter-spacing: 0.1rem;
        text-align: center;
    }

    .draw-tip img {
        display: inline-block;
        width: 30px;
    }

    .draw-tip p {
        width: 300px;
        margin-top: 0.28rem;
        /*color: #666666;*/
        color: #E8E8E8;

    }

    .draw-btns {
        width: 100vh;
        height: 60px;
        display: flex;
        /*justify-content: space-between;*/
        position: absolute;
        /*left: 0px;*/
        /*bottom: 8rem;*/
        background: #F7F8FA;
        border: 1px solid #E7E9EE;
        transform-origin: 30px 30px;
        transform: rotate(90deg);
    }

    .draw-btns .el-button {
        /*display: block;*/
        width: 92px;
        height: 30px;
        font-size: 0.24rem;
        text-align: center;
        line-height: 30px;
        color: white;
        border-radius: 4px;
        padding: 0px;
    }

    /*.draw-btns .el-button:first-child {*/
    /*	background: #f0f0f5;*/
    /*	border: 1px solid #f0f0f5;*/
    /*	color: #999999;*/
    /*}*/

    /*.draw-btns .el-button:last-child {*/
    /*	background: #3296fa;*/
    /*	box-shadow: 0px 0.04rem 0.1rem 0px rgba(0, 0, 0, 0.2);*/
    /*}*/

    .tip-success,
    .tip-waning {
        width: 100%;
        position: fixed;
        left: 0;
        top: -0.8rem;
        background: #f0f9eb;
        z-index: 999;
        color: #67c23a;
        font-size: 0.16rem;
        text-align: center;
        height: 0.8rem;
        line-height: 0.8rem;
        transition: 0.5s;
    }

    .tip-waning {
        background: #fdf6ec;
        color: #e6a23c;
    }

    .colorDiv {
        display: flex;
    }

    .colorText {
        width: 56px;
        height: 60px;
        font-size: 14px;
        margin-left: 25px;
        /*margin-top: 21px;*/
        /*font-family: PingFang SC-Regular, PingFang SC;*/
        /*font-weight: 400;*/
        color: #3D3D3D;
        line-height: 60px;
        /*-webkit-background-clip: text;*/
        /*-webkit-text-fill-color: transparent;*/

    }

    .blackSelected {
        display: flex;
    }

    .blackSelected .blackBored {
        display: inline-flex;
        width: 30px;
        height: 30px;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        border: 2px solid #333333;
        margin-left: 20px;
        margin-top: 16px;
    }

    .blackSelected .blackColor {
        width: 20px;
        height: 20px;
        background: #333333;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        margin: auto;
    }

    .blackSelected .redColor {
        width: 30px;
        height: 30px;
        background: #FF0000;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        margin-left: 20px;
        margin-top: 16px;
    }


    .redSelected {
        display: flex;
    }

    .redSelected .redBored {
        display: inline-flex;
        width: 30px;
        height: 30px;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        border: 2px solid #FF0000;
        margin-left: 20px;
        margin-top: 16px;
    }

    .redSelected .redColor {
        width: 20px;
        height: 20px;
        background: #FF0000;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        margin: auto;
    }

    .redSelected .blackColor {
        width: 30px;
        height: 30px;
        background: #333333;
        border-radius: 114px 114px 114px 114px;
        opacity: 1;
        margin-left: 20px;
        margin-top: 16px;
    }


    .btnDiv {
        display: flex;
        position: absolute;
        right: 17px;
        height: 30px;
        margin-top: 17px;
    }

    .chongxieBtn {
        /*color: black;*/
        /*background-color: #E7EDFC;*/
        /*border: 0px;*/
    }

    .wanchengBtn {

    }


</style>
